const base_url = 'https://youtube-v31.p.rapidapi.com';

const options = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': process.env.REACT_APP_API_KEY,
      'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    },
   
  };
  export const  Fetch = async(url)=>{
   const data = await fetch(`${base_url}/${url}`, options);
   const parseData = data.json();
   return parseData;
  }
  
  